import { createI18n } from 'vue-i18n';

import { messages } from './locales';

const savedLocale = localStorage.getItem('selectedLocale') || 'da';

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages,
});

export default i18n;
